module.exports = __webpack_public_path__ + "img/Schmetterling.60525783.svg";